import { render, staticRenderFns } from "./index-view.vue?vue&type=template&id=67346c8a&scoped=true"
import script from "./index-view.vue?vue&type=script&lang=js"
export * from "./index-view.vue?vue&type=script&lang=js"
import style0 from "./index-view.vue?vue&type=style&index=0&id=67346c8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67346c8a",
  null
  
)

export default component.exports